import { axiosNode } from '../config/axiosConfig';
import { alertErrorResponse } from '../utils/alertResponseHttpUtil';

const RUTA_TIPO_DOCUMENTOS = 'tipo-documentos';

const buscarTodos = async () => {
  try {
    const response = await axiosNode.get(RUTA_TIPO_DOCUMENTOS);
    return response.data;
  } catch (error) {
    alertErrorResponse(error.response?.data);
  }
};

export default { buscarTodos };
